import type { ReactNode } from 'react';
import { XIcon } from '@/components/layout/icons';

type Props = {
  readonly label: ReactNode;
  /** Accessible name of the remove control — the chip cannot phrase it itself. */
  readonly removeLabel: string;
  readonly onRemove: () => void;
};

/** The removable filter chip: the pill plus its remove control, as the customer app's lists draw it. */
export function FilterChip({ label, removeLabel, onRemove }: Props) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-interactive-subtle-bg px-3 py-1 text-base-sm font-medium text-text-primary">
      {label}
      <button
        type="button"
        onClick={onRemove}
        aria-label={removeLabel}
        className="inline-flex h-4 w-4 items-center justify-center rounded-full text-text-tertiary transition-colors hover:bg-hover-bg hover:text-text-primary focus-visible:outline-none focus-visible:shadow-focus"
      >
        <XIcon className="h-3 w-3" aria-hidden />
      </button>
    </span>
  );
}
